import { render, staticRenderFns } from "./WorkingHoursInput.vue?vue&type=template&id=354bfef6&scoped=true"
import script from "./WorkingHoursInput.vue?vue&type=script&lang=js"
export * from "./WorkingHoursInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bfef6",
  null
  
)

export default component.exports